import React from 'react';
import { Box, Button, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { PRESETS } from '../../utils/usagePeriod';
import { formatRange } from '../../utils/numberFormat';

/**
 * Selettore di periodo: quattro preset, nessun date picker libero.
 * «Anno corrente» è la finestra del contratto ed è quella che il cliente userà davvero; gli altri
 * servono a capire un picco.
 */
const UsagePeriodSelector = ({ preset, onPresetChange, from, to, onExport, exportDisabled }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
    <ToggleButtonGroup
      size="small"
      exclusive
      value={preset}
      onChange={(event, value) => value && onPresetChange(value)}
      aria-label="Periodo"
    >
      {PRESETS.map((p) => (
        <ToggleButton key={p.id} value={p.id} aria-label={p.label}>
          {p.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>

    <Typography variant="body2" color="text.secondary" sx={{ fontVariantNumeric: 'tabular-nums' }}>
      {formatRange(from, to)}
    </Typography>

    <Button
      size="small"
      variant="outlined"
      startIcon={<FileDownloadIcon />}
      onClick={onExport}
      disabled={exportDisabled}
    >
      Esporta CSV
    </Button>
  </Box>
);

export default UsagePeriodSelector;
